import { isGlobalFeatureEnabled } from 'owa-feature-flags';

export function isPrefetchDisabled(): boolean {
    return isGlobalFeatureEnabled('fwk-prefetch-data-off');
}
